"use strict";

exports.__esModule = true;
exports.PlantStateActivitiesScreen = void 0;
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactIntl = require("react-intl");
var _System = require("../../../System");
var _Core = require("../../Core");
var _CreatePlantStateActivitiesScreen = require("../CreatePlantStateActivitiesScreen");
var _UpdatePlantStateActivitiesScreen = require("../UpdatePlantStateActivitiesScreen");
var _MasterDetailView = require("../../Core/MasterDetailView");
var _App = require("../../App");
var _PlantStateActivitiesToolbar = require("../PlantStateActivitiesToolbar");
var _PlantStateActivitiesListView = require("../PlantStateActivitiesListView");
var _class, _PlantStateActivitiesScreen;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Screen which allows users view the plant state activities and click through to edit or create
 */
var PlantStateActivitiesScreen = exports.PlantStateActivitiesScreen = (0, _Core.withTranslator)(_class = (_PlantStateActivitiesScreen = /*#__PURE__*/function (_Component) {
  function PlantStateActivitiesScreen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      filterOnEnabled: true
    };
    _this.handleSelect = function (selected) {
      var _this$props = _this.props,
        history = _this$props.history,
        id = _this$props.match.params.id;
      if (selected === id || selected !== undefined) {
        return;
      }
      history.push((0, _System.getScreenLocation)("PlantStateActivities"));
    };
    return _this;
  }
  _inheritsLoose(PlantStateActivitiesScreen, _Component);
  var _proto = PlantStateActivitiesScreen.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var filterOnEnabled = this.state.filterOnEnabled;
    var _this$props2 = this.props,
      translator = _this$props2.translator,
      id = _this$props2.match.params.id;
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement(_MasterDetailView.MasterDetailView, {
      selected: id,
      onSelect: this.handleSelect,
      renderMaster: function renderMaster() {
        return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
          title: translate("PlantStateActivitiesScreen.title", "Activities")
        }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
          title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "PlantStateActivitiesMasterDetail.navbar.title",
            defaultMessage: "Activities"
          })
        }), /*#__PURE__*/_react["default"].createElement(_PlantStateActivitiesToolbar.PlantStateActivitiesToolbar, {
          onChangeEnabledToggle: function onChangeEnabledToggle(value) {
            return _this2.setState(Object.assign({}, _this2.state, {
              filterOnEnabled: value
            }));
          },
          enabledFilterOn: filterOnEnabled
        }), /*#__PURE__*/_react["default"].createElement(_PlantStateActivitiesListView.PlantStateActivitiesListView, {
          enabledFilterOn: filterOnEnabled
        }));
      },
      renderDetail: function renderDetail() {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: (0, _System.getScreenPath)("CreatePlantStateActivities"),
          element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
            component: _CreatePlantStateActivitiesScreen.CreatePlantStateActivitiesScreen
          })
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: (0, _System.getScreenPath)("UpdatePlantStateActivities"),
          element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
            component: _UpdatePlantStateActivitiesScreen.UpdatePlantStateActivitiesScreen
          })
        }));
      }
    });
  };
  return PlantStateActivitiesScreen;
}(_react.Component), _PlantStateActivitiesScreen.defaultProps = {
  match: undefined,
  translator: undefined
}, _PlantStateActivitiesScreen)) || _class;